import { Typography, Box, Divider, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { fetchHolidaysFull } from './saga';

export default function HolidaySchedule() {
  const [apiHolidays, setApiHolidays] = useState<string[]>([]);

  useEffect(() => {
    let mounted = true;
    fetchHolidaysFull()
      .then((res: any) => {
        if (!mounted) return;
        if (Array.isArray(res)) {
          const mapped = res
            .map((item: any) => item.HolidayName || item.Name || item.name || item || '')
            .filter(Boolean);
          setApiHolidays(mapped);
        }
      })
      .catch(() => {
        // swallow error for now; keep hardcoded list
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Box className='urc-container' sx={{ p: 2 }}>
      <Typography variant='h5' fontWeight={600} gutterBottom>
        Holiday Schedule
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Typography variant='h6' fontWeight={700} sx={{ mb: 3 }}>
        Fully Observed Holidays
      </Typography>

      <Stack spacing={1}>
        {apiHolidays.map((holiday) => (
          <Typography key={`hard-${holiday}`} variant='body1'>
            {holiday}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}
